/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-return-assign */
import React from 'react';

import styled from 'styled-components';

import { device } from 'helpers/screenSizes';
import { FastForward } from 'styles/assets/icons';

export const SecondaryHeaderWrapper = styled.div`
  ${'' /* height: 32px; */}
  position: sticky;
  top: 0px;
  z-index: 6;
  border-bottom: 2px solid ${props => props.theme.primaryBackground};
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 100%;

  .competition-banner {
    background-color: #ffc100;
    font-size: 12.1px;
    font-family: var(--fontRegular);
    letter-spacing: 0.3px;
    text-align: center;
    color: #602f04;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    flex-basis: 100%;

    @media ${device.down.md} {
      height: 44px;
    }

    .fast-forward {
      margin: 0 8px;
      transform: translate(0, -1px);
    }
  }
`;

const CryptoTradingLeagueHeader = props => {
  return (
    <SecondaryHeaderWrapper className="header-wrapper">
      <div
        data-testid="competition-banner"
        aria-hidden="true"
        className="competition-banner"
        onClick={() =>
          (window.location = 'https://www.delta.exchange/app/crypto_trading_league')
        }
      >
        <p>
          CRYPTO TRADING LEAGUE
          <FastForward className="fast-forward" />
          <span style={{ fontWeight: 500 }}>Win up to</span> 25 BTC!
        </p>
      </div>
    </SecondaryHeaderWrapper>
  );
};

export default CryptoTradingLeagueHeader;
